import { Anchored } from "./anchored.js";
import { Slot } from "./slot.js";
/**
 * {@link https://html.spec.whatwg.org/#concept-row}
 *
 * @public
 */
export class Row {
    static of(y) {
        return new Row(y);
    }
    _y;
    constructor(y) {
        this._y = y;
    }
    get y() {
        return this._y;
    }
    get anchor() {
        return Slot.of(0, this._y);
    }
    compare(anchored) {
        return Anchored.compare(this, anchored);
    }
    equals(value) {
        return value instanceof Row && value._y === this._y;
    }
    toJSON() {
        return {
            y: this._y,
        };
    }
}
/**
 * @public
 */
(function (Row) {
    function isRow(value) {
        return value instanceof Row;
    }
    Row.isRow = isRow;
    /**
     * {@link https://html.spec.whatwg.org/#concept-row-group}
     */
    class Group {
        static of(element, y, height) {
            return new Group(element, y, height);
        }
        _element;
        _y;
        _height;
        constructor(element, y, height) {
            this._element = element;
            this._y = y;
            this._height = height;
        }
        get element() {
            return this._element;
        }
        get y() {
            return this._y;
        }
        get anchor() {
            return Slot.of(0, this._y);
        }
        get height() {
            return this._height;
        }
        compare(anchored) {
            return Anchored.compare(this, anchored);
        }
        equals(value) {
            return (value instanceof Group &&
                value._element.equals(this._element) &&
                value._y === this._y &&
                value._height === this._height);
        }
        toJSON() {
            return {
                element: this._element.path(),
                y: this._y,
                height: this._height,
            };
        }
    }
    Row.Group = Group;
    (function (Group) {
        function isGroup(value) {
            return value instanceof Group;
        }
        Group.isGroup = isGroup;
    })(Group = Row.Group || (Row.Group = {}));
    Row.group = Group.of, Row.isGroup = Group.isGroup;
})(Row || (Row = {}));
//# sourceMappingURL=row.js.map